module.exports = __webpack_public_path__ + "static/media/snowfall_1.5c829bd1.png";